import { LoginClientManager } from "@tlc/ls2pac/app/ClientManagers/LoginClientManager";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSignInWithGoogleRedirect } from "../auth/AuthGuardProvider";

export const LoginPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const getSignInWithGoogleRedirect = useSignInWithGoogleRedirect();

  React.useEffect(() => {
    const search = new URLSearchParams(location.search);
    const to = search.get("to") || "/myaccount/summary";
    const from = search.get("from") || "/";

    LoginClientManager.promptIfNotLoggedIn(
      () => {
        return navigate(to, { replace: true }); // remove /login from history
      },
      (prevPath?: string) => {
        if (from) {
          navigate(from, { replace: true });
        } else if (prevPath) {
          // TODO I think this can be removed, need to test more
          // handle legacy routes for now. remove after search result refactoring is complete
          prevPath.indexOf("section=") !== -1
            ? (window.location.hash = prevPath.substring(1))
            : navigate(prevPath, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      },
      getSignInWithGoogleRedirect(to),
      from
    );
  }, []);

  return <></>;
};
